/**
 * Created by mykurisu on 2017/9/25.
 */
import React from 'react'
import axios from 'axios'
import {Dialog, Toptips} from 'react-weui'


class DeleteComponent extends React.Component {
    constructor() {
        super();
        this.state = {
            dialogButton: [
                {
                    type: 'default',
                    label: '取消',
                    onClick: this.handleDialogShow.bind(this)
                },
                {
                    type: 'primary',
                    label: '确定',
                    onClick: this.handleDelete.bind(this)
                }
            ],
            dialogShow: true,
            dialogMsg: '',
            tipsShow: false
        }
    }

    handleDialogShow() {
        this.props.handleHideDelete();
    }

    handleDelete() {
        let target_id = this.props.target_id;
        let target_url = '';
        if (this.props.type === 'lecture'){
            target_url = `/api/lecture/${target_id}/delete`
        }else {
            target_url = `/api/channel/${target_id}/delete`
        }

        axios.post(target_url).then((res) => {
            if (res.data.code === 0) {
                window.location = `/liveroom/${this.props.liveroom_id}`;
            }else {
                this.setState({
                    dialogShow: false,
                    dialogMsg: res.data.msg,
                    tipsShow: true
                });
            }
        });
    }

    render() {
        return (
            <div>
                <Dialog title={'温馨提示'} buttons={this.state.dialogButton}
                        show={this.state.dialogShow}>
                    <p>
                        <span>转载的{this.props.type === 'lecture' ? '课程' : '专栏'}删除后不能再次转载！</span>
                        <br />
                        <span>确定要删除吗？</span>
                    </p>
                </Dialog>

                <Toptips type="warn" show={this.state.tipsShow}>{this.state.dialogMsg}</Toptips>
            </div>
        )
    }
}

export default DeleteComponent



// WEBPACK FOOTER //
// ./src/components/details/DeleteComponent.js